import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import AppProvider from './providers/AppProvider';
import App from './components/App';

import './assets/styles/index.css';

ReactDOM.render(
  <>
    <HashRouter basename="">
      <AppProvider>
        <App />
      </AppProvider>
    </HashRouter>
  </>,
  document.getElementById('root'),
);
